import { render } from "./App.vue?vue&type=template&id=6d9e050c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6d9e050c&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__